<template>
  <div class="basic_wrap">
    <div class="rebate_title">
      <span>{{ $t("今日可兑换") }}
        <span>0.00</span>
      </span>
    </div>
    <div class="sideBox">
      <div class="tab_side">
        <div :class="active == 1 ? 'tab_side_title active' : 'tab_side_title'" @click="choseType(1)">
          <svg width="25" height="25" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M35.5972 78.5887C30.5472 76.5419 26.0829 73.2766 22.6031 69.0842C19.1234 64.8919 16.7364 59.9032 15.6555 54.5637C14.5747 49.2242 14.8335 43.7002 16.409 38.4851C17.9844 33.27 20.8274 28.5262 24.684 24.6775C27.746 21.6098 31.3831 19.176 35.3872 17.5154C39.3913 15.8548 43.6836 15 48.0185 15C52.3535 15 56.6458 15.8548 60.6499 17.5154C64.6539 19.176 68.2911 21.6098 71.353 24.6775C76.7306 30.0642 80.0809 37.1433 80.8368 44.7162C81.5927 52.2891 79.7076 59.8905 75.5008 66.2334C71.294 72.5763 65.0239 77.2709 57.7521 79.5225C50.4803 81.774 42.6536 81.4441 35.5972 78.5887ZM45.7517 77.5027C45.5513 77.4068 45.3519 77.3099 45.1515 77.2075C45.0847 77.1731 45.006 77.1321 44.9263 77.0836L37.9529 75.8447C40.4663 76.7448 43.0895 77.3025 45.7517 77.5027ZM26.2541 63.5587C26.4061 63.8474 26.5774 64.1297 26.7509 64.4335C26.8587 64.6059 26.9568 64.7847 27.0602 64.9636C28.3057 67.1674 29.7416 69.2583 31.3513 71.2121L45.1526 73.6771C45.2894 73.5123 45.4069 73.3603 45.519 73.216C46.5373 71.8467 47.6257 70.3513 48.8359 68.6588L42.4456 57.6075C42.4093 57.6058 42.3733 57.6011 42.3378 57.5935L42.23 57.5795C38.5987 57.0766 35.0003 56.3593 31.4537 55.4312L26.2541 63.5587ZM72.4048 54.5866L65.4217 67.6224C65.7914 68.8273 66.0794 70.0558 66.2839 71.2994C67.2225 70.568 68.115 69.7793 68.9564 68.9379C73.5631 64.3269 76.5179 58.3242 77.3619 51.862C75.7833 52.8983 74.1259 53.8093 72.4048 54.5866ZM50.2228 46.0217C49.6107 47.2197 48.92 48.5481 48.24 49.8366C47.1624 51.8836 46.158 53.7678 45.1946 55.5648L51.7779 66.9448C55.369 66.9054 58.9501 66.5554 62.4809 65.8987L69.1471 53.4705C68.9133 53.0094 68.7074 52.6086 68.5092 52.238C67.1152 49.6108 65.5712 47.0659 63.885 44.6158L50.2228 46.0217ZM21.3983 37.7941C21.3164 37.918 21.2281 38.0419 21.144 38.1658C20.4056 39.2072 19.7429 40.3002 19.1612 41.4366C17.9282 46.8778 18.2504 52.556 20.0912 57.8229C21.2414 58.997 22.5241 60.0335 23.9135 60.9117L29.0786 52.8208C28.3155 49.0786 27.9324 45.2688 27.9353 41.4495L21.5029 37.6411L21.3983 37.7941ZM53.6454 23.1272C51.9298 23.2349 50.1808 23.4094 48.4954 23.5894L47.2874 23.7132C47.1796 23.7262 47.0535 23.7402 46.9231 23.7682L43.2592 34.7915C43.6126 35.1428 43.9618 35.494 44.3142 35.8452L45.436 36.9678L45.367 37.0432L46.2787 38.0623C47.4889 39.4187 48.7432 40.8236 49.9707 42.2144C50.0784 42.3383 50.1862 42.4622 50.294 42.6001L63.5661 41.2362L63.6296 41.0918C64.2762 39.5081 64.9433 37.8598 65.5575 36.2384C65.8948 35.3496 66.1912 34.4134 66.4735 33.5052L57.2317 23.097C56.8125 23.069 56.3858 23.0625 55.9246 23.0625C55.264 23.0593 54.5635 23.0798 53.6454 23.1272ZM27.0893 27.0832C26.7563 27.4139 26.4266 27.764 26.0893 28.1228C25.5906 29 25.1395 29.9034 24.7379 30.8291C24.2584 31.9301 23.8241 33.0915 23.4038 34.2098L23.2379 34.6504C23.2314 34.6709 23.2228 34.6924 23.2163 34.7194L29.6821 38.5407C32.3998 36.8128 35.2413 35.2878 38.1835 33.9781C38.6739 33.7627 39.1771 33.558 39.661 33.3727C39.8528 33.2973 40.0399 33.2215 40.2224 33.1454L43.6191 22.9203C41.939 21.7475 40.109 20.8054 38.1781 20.1192C38.1695 20.1128 38.1566 20.1128 38.1447 20.1052C33.9806 21.5683 30.2012 23.9538 27.0893 27.0832ZM60.0648 21.1686L69.2732 31.538C69.5426 31.6349 69.8314 31.7384 70.1148 31.8547C71.4342 32.3981 72.7171 33.026 73.9555 33.7347C70.8447 28.0858 65.9736 23.6073 60.0832 20.98C60.0767 21.0414 60.0713 21.1039 60.0594 21.1653L60.0648 21.1686Z"
              fill="currentColor" />
          </svg>
          <div>{{ $t("体育") }}</div>
        </div>
        <div :class="active == 2 ? 'tab_side_title active' : 'tab_side_title'" @click="choseType(2)">
          <svg width="25" height="25" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_5613_45897)">
              <path
                d="M4.26397 71.3699C3.13232 71.3699 2.04702 70.9203 1.24682 70.1201C0.446618 69.3199 -0.00292969 68.2346 -0.00292969 67.103V27.6341C-0.00292969 26.5024 0.446618 25.4171 1.24682 24.6169C2.04702 23.8167 3.13232 23.3672 4.26397 23.3672H91.7302C92.8618 23.3672 93.9471 23.8167 94.7473 24.6169C95.5475 25.4171 95.9971 26.5024 95.9971 27.6341V67.103C95.9971 68.2346 95.5475 69.3199 94.7473 70.1201C93.9471 70.9203 92.8618 71.3699 91.7302 71.3699H4.26397ZM63.9953 30.8343V63.9028C63.9953 64.4686 64.2201 65.0113 64.6202 65.4114C65.0203 65.8115 65.5629 66.0362 66.1287 66.0362H88.53C89.0958 66.0362 89.6385 65.8115 90.0386 65.4114C90.4387 65.0113 90.6634 64.4686 90.6634 63.9028V30.8343C90.6634 30.2684 90.4387 29.7258 90.0386 29.3257C89.6385 28.9256 89.0958 28.7008 88.53 28.7008H66.1287C65.5629 28.7008 65.0203 28.9256 64.6202 29.3257C64.2201 29.7258 63.9953 30.2684 63.9953 30.8343ZM34.6603 30.8343V63.9028C34.6603 64.4686 34.8851 65.0113 35.2852 65.4114C35.6853 65.8115 36.228 66.0362 36.7938 66.0362H59.195C59.7608 66.0362 60.3035 65.8115 60.7036 65.4114C61.1037 65.0113 61.3285 64.4686 61.3285 63.9028V30.8343C61.3285 30.2684 61.1037 29.7258 60.7036 29.3257C60.3035 28.9256 59.7608 28.7008 59.195 28.7008H36.7938C36.2289 28.7022 35.6876 28.9276 35.2886 29.3276C34.8897 29.7275 34.6657 30.2694 34.6657 30.8343H34.6603ZM5.32537 30.8343V63.9028C5.32537 64.4686 5.55014 65.0113 5.95024 65.4114C6.35034 65.8115 6.89299 66.0362 7.45882 66.0362H29.8601C30.4259 66.0362 30.9685 65.8115 31.3686 65.4114C31.7687 65.0113 31.9935 64.4686 31.9935 63.9028V30.8343C31.9935 30.2684 31.7687 29.7258 31.3686 29.3257C30.9685 28.9256 30.4259 28.7008 29.8601 28.7008H7.45882C6.89299 28.7008 6.35034 28.9256 5.95024 29.3257C5.55014 29.7258 5.32537 30.2684 5.32537 30.8343ZM70.0479 59.2369C68.9673 53.6494 72.0427 50.0087 80.1498 43.827C78.9813 43.8989 77.8123 43.6962 76.7363 43.235C75.6807 42.7653 74.522 42.5758 73.3718 42.6845C72.7372 42.8462 72.1443 43.1413 71.6328 43.5502C71.1212 43.9591 70.7027 44.4724 70.4052 45.0559H66.6674V36.7013H70.6293C70.5738 37.6613 71.2949 37.5194 71.7941 37.2346C72.6341 36.8189 73.5785 36.6615 74.5079 36.7823C75.9622 37.0689 77.3972 37.4458 78.8046 37.9109C80.4176 38.4127 82.107 38.6233 83.7937 38.5328C85.0625 38.4996 86.2712 37.9847 87.1742 37.0928L89.3364 39.591C79.609 49.4124 81.976 55.5098 83.0609 59.2337L70.0479 59.2369ZM40.7129 59.2369C39.6313 53.6494 42.7077 50.0087 50.8138 43.827C49.6453 43.8991 48.4762 43.6963 47.4002 43.235C46.3444 42.7652 45.1852 42.5756 44.0347 42.6845C43.4002 42.8461 42.8074 43.1412 42.296 43.5501C41.7846 43.959 41.3664 44.4724 41.0692 45.0559H37.3271V36.7013H41.2879C41.2335 37.6613 41.9535 37.5194 42.4528 37.2346C43.2931 36.8188 44.2378 36.6614 45.1676 36.7823C46.6215 37.069 48.0562 37.446 49.4633 37.9109C51.0762 38.4127 52.7656 38.6233 54.4524 38.5328C55.7212 38.4996 56.9298 37.9847 57.8328 37.0928L59.9951 39.591C50.2676 49.4124 52.6347 55.5098 53.7195 59.2337L40.7129 59.2369ZM11.378 59.2369C10.2963 53.6494 13.3727 50.0087 21.4799 43.827C20.3114 43.8989 19.1423 43.6962 18.0663 43.235C17.0105 42.7652 15.8513 42.5756 14.7008 42.6845C14.0664 42.8463 13.4737 43.1415 12.9624 43.5504C12.451 43.9593 12.0327 44.4725 11.7353 45.0559H7.99218V36.7013H11.954C11.8985 37.6613 12.6196 37.5194 13.1189 37.2346C13.9588 36.8189 14.9032 36.6615 15.8326 36.7823C17.2865 37.0691 18.7212 37.446 20.1283 37.9109C21.7412 38.4128 23.4306 38.6234 25.1174 38.5328C26.3862 38.4996 27.5948 37.9847 28.4979 37.0928L30.659 39.591C20.9316 49.4124 23.2986 55.5098 24.3835 59.2337L11.378 59.2369Z"
                fill="currentColor" />
            </g>
            <defs>
              <clipPath id="clip0_5613_45897">
                <rect width="96" height="96" fill="" />
              </clipPath>
            </defs>
          </svg>
          <div>{{ $t("电子") }}</div>
        </div>
        <div class="tab_his_title" @click="toHis">
          <div>{{ $t("历史") }}</div>
        </div>
      </div>
      <!-- <div class="history_content">
        <div class="history_items">
          <div class="title">
            <div class="name">
              <img src="https://img2.thethsdnadagvx.com/gpmaster/0a63f41c-d4c8-4fa6-b2c4-09a7a5db511b.png" alt="">
              <div class="name_money">
                <span>Apostas Válidas</span>
                <span class="money">0.00</span>
              </div>
            </div>
            <div class="content">
              <div class="bacColor" />
              <span class="bacColor_content">Aposte 1 para receber 0%</span>
            </div>
          </div>
          <div class="history-item-right">
            <div class="rebatede">
              <div class="is-collected">
                Taxa de Cashback
              </div>
              <span class="wh">0%</span>
            </div>
            <div class="rebatede">
              <div class="is-collected">
                Coletável
              </div>
              <span class="huang">0,00</span>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  name: "History",
  components: {},
  data() {
    return {
      active: 1,
    };
  },
  created() { },
  beforeDestroy() { },
  mounted() { },
  methods: {
    tabChange(v) {
      this.active = v;
    },
    toHis() { },
    choseType(v) {
      this.active = v;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/variables.less";

.nav_box {
  // width: 95%;
  background-color: @secondary-color;
  display: flex;
  align-items: center;
  // margin: 0 auto 0.2rem auto;
}

.basic_wrap {
  background-color: @activityColor;
  min-height: 100vh;
  width: 100%;
}

.sideBox {
  display: flex;

  .side_content {
    width: 75%;
    height: 15rem;
    overflow-y: scroll;

    .side_img {
      width: 95%;
      background-color: @secondary-color;
      text-align: center;
      margin-top: 0.2rem;
      padding: 0.1rem;

      img {
        width: 95%;
      }
    }
  }
}

.tab_side {
  display: flex;
  flex-direction: column;
  // padding-left: 0.4rem;
  width: 25%;

  .tab_side_title {
    width: 2rem;
    height: 1.5rem;
    background-color: @secondary-color;
    border-radius: 0.3rem;
    text-align: center;
    margin: 0 auto;
    margin-top: 0.3rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    img {
      width: 0.6rem;
      margin-top: 0.1rem;
    }

    div {
      font-size: 0.28rem;
    }
  }

  .tab_his_title {
    width: 1.8rem;
    height: 0.8rem;
    background-color: @rechargeColor;
    border-radius: 0.3rem;
    text-align: center;
    margin: 0 auto;
    margin-top: 0.3rem;

    div {
      font-size: 0.28rem;
      margin-top: 0.22rem;
    }
  }
}

.active {
  background-color: @ButtonColor !important;
}

.rebate_title {
  padding: 0 0.2rem;
  display: flex;
  justify-content: space-between;
  gap: 0.06rem;
  font-size: 0.3rem;
  margin-top: 0.3rem;
  margin-bottom: 0.3rem;

  span {
    span {
      color: @ButtonColor !important;
    }
  }
}

.history_content {
  padding: 0.3rem;
  width: 75%;

  .history_items {
    background-color: @secondary-color;
    height: 1.5rem;
    border-radius: 0.2rem;
    display: flex;
    padding: 0.2rem;
    margin-bottom: 0.3rem;
    align-items: center;

    .title {
      width: 55%;

      .name {
        display: flex;
        align-items: center;
        gap: 0.08rem;
        font-size: 0.3rem;

        img {
          width: 0.7rem;
        }

        .name_money {
          font-size: 0.26rem;

          .money {
            color: #fff !important;
            margin-left: 0.1rem;
          }
        }
      }

      .content {
        display: flex;
        align-items: center;
        font-size: 0.26rem;
        position: relative;
        margin-bottom: 0.2rem;
        margin-top: 0.2rem;

        .bacColor {
          height: 0.3rem;
          background-color: @bodercolor;
          position: relative;
          display: inline-block;
          width: 90%;
          overflow: hidden;
          vertical-align: middle;
          border-radius: 1rem;
        }

        .bacColor_content {
          width: 90%;
          text-align: center;
          font-size: 0.26rem;
          position: absolute;
          top: 55%;
          left: 45%;
          color: #fff;
          transform: translate(-50%, -50%);
          -webkit-line-clamp: 1;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          text-overflow: ellipsis;
          word-break: break-all;
          overflow: hidden;
          line-height: normal;
        }

        .currency {
          height: 0.3rem;
          margin-right: 0.04rem;
          line-height: 0.3rem;
          font-size: 0.3rem;
          border-radius: 0.2rem;
          background-color: @rechargeColor;
          color: @activityColor;
        }

        .money {
          color: @rechargeColor;
          margin-right: 0.3rem;
        }

        .time {
          color: @popupTextColor;
          margin-right: 0.3rem;
        }

        .label {
          color: @popupTextColor;
        }

        .value {
          padding-left: 0.06rem;
          color: @rechargeColor;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }

    .history-item-right {
      width: 45%;
      display: flex;
      flex-direction: column;
      gap: 0.06rem;

      .rebatede {
        display: flex;
        justify-content: space-around;
        align-items: center;

        .is-collected {
          line-height: 1;
          width: 1.2rem;
          font-size: 0.26rem;
          color: @popupTextColor;
        }

        .wh {
          color: #fff !important;
          font-size: 0.28rem;
        }

        .huang {
          color: @rechargeColor !important;
          font-size: 0.28rem;
        }
      }
    }
  }
}
</style>